import {AttributeDefinitionView} from './attribute-schema.service';
import {Options} from '@angular-slider/ngx-slider';

export interface AttributeRangeBounds {
  min: number;
  max: number;
  step: number;
}

export interface AttributeRangeFilterValue {
  min: number;
  max: number;
}

export function parseRangeBounds(field: AttributeDefinitionView): AttributeRangeBounds {
  const defaults: AttributeRangeBounds = {min: 0, max: 100, step: 1};
  if (!field?.validationJson?.trim()) {
    return defaults;
  }
  try {
    const parsed = JSON.parse(field.validationJson) as Partial<AttributeRangeBounds>;
    return {
      min: numberOr(parsed.min, defaults.min),
      max: numberOr(parsed.max, defaults.max),
      step: numberOr(parsed.step, defaults.step),
    };
  } catch {
    return defaults;
  }
}

export function buildRangeSliderOptions(bounds: AttributeRangeBounds): Options {
  const step = bounds.step > 0 ? bounds.step : 1;
  return {
    floor: bounds.min,
    ceil: bounds.max,
    step,
    translate: (value: number): string => `${value}`,
  };
}

export function encodeRangeFilter(min: number, max: number, bounds: AttributeRangeBounds): string | null {
  if (min <= bounds.min && max >= bounds.max) {
    return null;
  }
  return JSON.stringify({min, max});
}

export function decodeRangeFilter(raw: string | null | undefined): AttributeRangeFilterValue | null {
  if (!raw?.trim()) {
    return null;
  }
  const trimmed = raw.trim();
  try {
    const parsed = JSON.parse(trimmed) as Partial<AttributeRangeFilterValue>;
    if (parsed.min !== undefined && parsed.max !== undefined) {
      return {min: Number(parsed.min), max: Number(parsed.max)};
    }
  } catch {
    const parts = trimmed.split('-').map(part => part.trim()).filter(Boolean);
    if (parts.length === 2) {
      return {min: Number(parts[0]), max: Number(parts[1])};
    }
  }
  return null;
}

function numberOr(value: unknown, fallback: number): number {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
}
